import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class RadioGroup extends React.PureComponent {
    static propTypes = {
        /** Expected to be one or more Radios */
        children: PropTypes.node.isRequired,

        /** The name given to each Radio */
        name: PropTypes.string.isRequired,

        /** The value of the selected item in the group */
        value: PropTypes.string,

        /** Change handler passed to each radio */
        onChange: PropTypes.func,

        /** Makes the group required */
        isRequired: PropTypes.bool,

        /** Makes all the Radios in the group disabled */
        isDisabled: PropTypes.bool,

        /** Makes the radio inputs arranged inline horizontally */
        isInline: PropTypes.bool,

        /** additional class applied to outer container */
        className: PropTypes.string
    };

    static defaultProps = {
        value: undefined,
        onChange: undefined,
        isRequired: false,
        isDisabled: false
    };

    render() {
        const {
            children,
            value,
            name,
            isRequired,
            isDisabled,
            onChange,
            isInline,
            className
        } = this.props;

        return (
            <div className={cx(className, {
                'sarsa-radio-group-inline': isInline
            })}>
                {React.Children.map(children, (child) => {
                    return React.cloneElement(child, {
                        isChecked: onChange ? value === child.props.value : undefined,
                        name,
                        isRequired,
                        isDisabled: isDisabled || child.props.isDisabled,
                        onChange
                    })
                })}
            </div>
        );
    }
}
